import { Directive, ElementRef, Input, OnInit, OnDestroy, Renderer2 } from '@angular/core';
import { Subscription } from 'rxjs';
import { skip } from 'rxjs/operators';
import { AuthorizationUtility } from './auth.utility';
import { AllowListAuthStore } from './allow-list-auth.store';

@Directive({
  standalone: true,
  selector: '[authorizeButton]',
})
export class AuthorizeButtonDirective implements OnInit, OnDestroy {

  private pageId!: string;
  private buttonId!: string;
  private configSub: Subscription;

  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
    private authUtility: AuthorizationUtility,
    private authStore: AllowListAuthStore,
  ) {
    // Re-evaluate whenever auth config reloads
    this.configSub = this.authStore.loaded$.pipe(skip(1)).subscribe(() => {
      if (this.pageId) this.updateViewState();
    });
  }

  ngOnInit(): void {
    this.updateViewState();
  }

  ngOnDestroy(): void {
    this.configSub.unsubscribe();
  }

  @Input() set authorizeButton(config: string[]) {
    this.pageId = config[0].trim();
    this.buttonId = config[1].trim();
  }

  private updateViewState() {
    const element = this.el.nativeElement;
    const isAllowed = this.authUtility.isButtonVisible(this.pageId, this.buttonId);

    if (!isAllowed) {
      this.renderer.setStyle(element, 'display', 'none');
    } else {
      this.renderer.removeStyle(element, 'display');
    }
  }
}
